import PolicyPage from '@/components/pageEditor/PolicyPage';

// المحتوى من قاعدة البيانات (صفحات الموقع) ويتعدّل من الواجهة للأدمن
const Terms = () => <PolicyPage slug="terms" />;

export default Terms;
